import { Link } from "react-router-dom";
import BgShape from "../images/hero/vidz.mov";
import HeroCar from "../images/hero/main-car.png";
import PosterImage from "../images/hero/poster.jpg";
import { useEffect, useState } from "react";
import whatsapp from "../images/logo/whatsapp.png";
import facebook from "../images/logo/fb.png";


function Hero() {
  const [goUp, setGoUp] = useState(false);
  //const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const openWhatsApp = () => {
    window.open('https://wa.me/16493413819', '_blank');    
  };

  const openfacebook = () => {
    window.open('https://www.instagram.com/priceisrightatv/', '_blank'); 
   };

  useEffect(() => {
    const onPageScroll = () => {
      if (window.pageYOffset > 600) {
        setGoUp(true);
      } else {
        setGoUp(false);
      }
    };

    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('scroll', onPageScroll);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('scroll', onPageScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);



  const [slideIn, setSlideIn] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    // Trigger the slide-in animation after a short delay
    const delay = setTimeout(() => {
      setSlideIn(true);
    }, 850); // Adjust the delay as needed

    // Clear the timeout on component unmount to avoid memory leaks
    return () => clearTimeout(delay);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const slideAnimation = {
    zIndex: 2,
    position: 'absolute',
    right: slideIn ? 40 : '-100%',
    transition: 'right 2.0s ease-in-out',
    width: '100%', // Set the maximum width to 100%
    height: 'auto', // Maintain the aspect ratio
    maxWidth: windowWidth < 768 ? '80%' : '55%', // Set maxWidth for mobile view
    marginTop: '5rem',
  };
  

  const containerStyle = {
    position: 'relative', height:'720px', marginTop:'-45px'
    //backgroundImage: 'linear-gradient(315deg, #00690a 0%, #3a9e0e 74%)',
    // Adjusted the color values to create a darker gradient
    // Add any other styles you need here
  };

  const bgImageStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%', // Adjust as needed
  height: '100%', // Adjust as needed
  objectFit: 'cover', // Ensure the video covers the entire element
  filter: 'brightness(65%)',   zIndex: '1010', 
  };


  return (
    <section id="home" className="banner-section" style={containerStyle}>
      <div className="container" >
      {/* <img src={BgShape} alt="Background Shape" style={bgImageStyle} /> */}

      <video src={BgShape}  poster={PosterImage} autoPlay muted loop  playsInline  style={bgImageStyle} />

      
      <div
  className="hero-content"
  style={{
    position: 'relative', marginTop:'3.5rem',
  //  zIndex: 2,
    height: '550px',
    width: '100%',
    display: 'flex', // Flexbox for centering
    alignItems: 'center', // Vertical centering
    justifyContent: 'center', // Horizontal centering
    textAlign: 'center', zIndex: '1010',   // Ensures text is centered within its block
  }}
>
  <div>
    <h1
      style={{
        color: 'white',
        fontFamily: "'Anton', 'Arial Black', sans-serif",
        textTransform: 'uppercase',
        fontSize: '6rem', // Default for desktop
        fontWeight: 'bold',
        letterSpacing: '1px', lineHeight: '1.5',
        // Media query for mobile
        ...(window.innerWidth <= 768 && { fontSize: '3.5rem' }), // Reduce by ~60% for smaller screens
      }}
    >
      WELCOME TO,
      <br />
      PRICE IS RIGHT ATV
    </h1>

    <h2
      style={{
        color: 'white', marginTop:'10px',
        fontFamily: "'Anton', 'Arial Black', sans-serif",
        fontSize: '4rem', lineHeight: '1.4', // Default for desktop
        ...(window.innerWidth <= 768 && { fontSize: '2.5rem' }), // Reduce size on mobile
      }}
    >
      Providenciales
      <br />
      Turks & Caicos
    </h2>
  </div>
</div>


    
    </div>

      {/* WhatsApp button */}


      <div
        onClick={openfacebook}
        className="whatsapp-btn"
        style={{
          position: 'fixed',
          bottom: '115px',
          left: '1rem',
          zIndex: '1000', 
        }}
      >
        <img src={facebook} alt="Facebook-img" style={{ height: 65, width: 65, borderRadius:'7px' }} />
      </div>



      <div
        onClick={openWhatsApp}
        className="whatsapp-btn"
        style={{
          position: 'fixed',
          bottom: '35px',
          left: '1rem',
          zIndex: '1000', 
        }}
      >
        <img src={whatsapp} alt="Facebook-img" style={{ height: 65, width: 65, borderRadius:'7px' }} />
      </div>




      {/* Scroll to top button */}
      <div style={{   background: 'linear-gradient(235deg, #f7e9a0, #ffcc00, #d4af37, #b8860b)',
          backgroundSize: '200% 200%',}} onClick={scrollToTop} className={`scroll-up ${goUp ? 'show-scroll' : ''}`}>
        <p style={{ fontSize: 22 }}>&#9650;</p>
      </div>
    </section>
  );
}

export default Hero;

const styles = {
  container: {
   // height: '110px',
    display: 'block', // Ensure it's a block element
   
  },
  // Media query to hide the container when the screen width is less than 500px
  '@media (max-width: 800px)': {
    container: {
      display: 'none',
      
    },
  },
};